import { z } from 'zod';

const nonNegativeNumberString = z.string().refine((val) => !val || (!isNaN(Number(val)) && Number(val) >= 0), {
  message: 'Must be a non-negative number',
});

const numberString = z.string().refine((val) => !val || !isNaN(Number(val)), {
  message: 'Must be a valid number',
});

export { nonNegativeNumberString, numberString };
